import SmallNotificationWindowWrapper from './SmallNotificationWindowWrapper'

export default SmallNotificationWindowWrapper
